export const LoanTypeCode = Object.freeze({
  DEVELOPMENT_LOAN_EE01: 'DEVELOPMENT_LOAN_EE01',
  DEVELOPMENT_LOAN_LT01: 'DEVELOPMENT_LOAN_LT01',
  CREDIT_LINE_EE: 'CREDIT_LINE_EE',
  CREDIT_LINE_LT: 'CREDIT_LINE_LT',
  CAR_LEASE_EE03: 'CAR_LEASE_EE03'
})
